export default __webpack_public_path__ + "static/mikko-avatar-5e0f051dcc1cc87a435cd046d761ca64.jpg";